import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Dialog, withStyles } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear";
import styles from "./HandOver.module.scss";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import HandOverCompleteCalenderDialog from "./HandOverCompleteCalenderDialog";
import { HANDOVER_DIALOGUES } from "./Constants";

const StyledClear = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

const StyledDialog = withStyles({
  paper: {
    maxWidth: 607,
    height: 653,
  },
})(Dialog);

class HandOverCompleteDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkBoxSelected: false,
    };
  }

  handleClose = () => {
    this.props.handleDialogChange(
      null,
      HANDOVER_DIALOGUES.COMPLETE,
      HANDOVER_DIALOGUES.COMPLETE
    );
  };

  handleNext = () => {
    this.props.handleDialogChange(
      HANDOVER_DIALOGUES.COMPLETE_CALENDER,
      HANDOVER_DIALOGUES.COMPLETE
    );
  };

  confirmText = () => {
    this.setState((prevState) => ({
      checkBoxSelected: !prevState.checkBoxSelected,
    }));
  };

  render() {
    return (
      <>
        {this.props.open ? (
          <StyledDialog open={this.props.open} onClose={this.handleClose}>
            <div className={styles.dialog}>
              <Grid
                container
                data-testid="handOverCompleteDialog"
                className={styles.dialogContainer}
                justify="center"
              >
                <Grid item md={12} className={styles.cancel}>
                  <div>
                    <button
                      data-testid="handOverCompleteCloseDialog"
                      onClick={this.handleClose}
                    >
                      <StyledClear />
                    </button>
                  </div>
                </Grid>

                <Grid item md={9}>
                  <div className={styles.brightRedTitle}>
                    <div className={styles.warning} />
                    {this.props.t("HandOverCompleteDialog.title")}
                  </div>
                </Grid>

                <Grid item md={9}>
                  <div className={styles.body}>
                    <div className={styles.text}>
                      {this.props.t("HandOverCompleteDialog.bodyText1")}
                    </div>
                    <div className={styles.text}>
                      {this.props.t("HandOverCompleteDialog.bodyText2")}
                    </div>
                    <ul>
                      <li className={styles.bold}>
                        {this.props.t("HandOverCompleteDialog.bodyBullet1")}
                      </li>
                      <li className={styles.bold}>
                        {this.props.t("HandOverCompleteDialog.bodyBullet2")}
                      </li>
                      <li>
                        {this.props.t("HandOverCompleteDialog.bodyBullet3")}
                      </li>
                      <li>
                        {this.props.t("HandOverCompleteDialog.bodyBullet4")}
                      </li>
                      <li>
                        {this.props.t("HandOverCompleteDialog.bodyBullet5")}
                      </li>
                      <li>
                        {this.props.t("HandOverCompleteDialog.bodyBullet6")}
                      </li>
                      <li>
                        {this.props.t("HandOverCompleteDialog.bodyBullet7")}
                      </li>
                    </ul>
                  </div>
                  <div className={styles.paddingTop}>
                    <CheckBox
                      id="chkBoxConfirm"
                      boldCheck={true}
                      checked={this.state.checkBoxSelected}
                      label={this.props.t(
                        "HandOverCompleteDialog.bodyConfirmText"
                      )}
                      onChange={this.confirmText}
                      textClass={styles.chkBoxConfirm}
                    />
                  </div>
                </Grid>

                <Grid item md={9}>
                  <div className={styles.dialogActions}>
                    <Button
                      className={styles.cancel}
                      name="handOverCompleteCancel"
                      data-testid="handOverCompleteCancel"
                      onClick={this.handleClose}
                    >
                      {this.props.t("HandOverCompleteDialog.cancel")}
                    </Button>
                    <Button
                      className={styles.next}
                      name="handOverCompleteNext"
                      data-testid="handOverCompleteNext"
                      disabled={!this.state.checkBoxSelected}
                      onClick={this.handleNext}
                    >
                      {this.props.t("HandOverCompleteDialog.next")}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </StyledDialog>
        ) : (
          ""
        )}
        <HandOverCompleteCalenderDialog
          {...this.props}
          todayDate={this.props.customerReservation.todayDate}
          open={this.props.dialogBoxes[HANDOVER_DIALOGUES.COMPLETE_CALENDER]}
        />
      </>
    );
  }
}

export default withTranslation("emp")(HandOverCompleteDialog);
